import { createParser } from 'nuqs';

import { MarketplaceChannel } from '~/types/marketplace';

// Intentionally accepts any non-empty string — channel validation authority has moved to
// the enterprise API (fetchEnterprisePartnerConfig returns null for unknown channels).
// Do not restore an allowlist here; add validation at the API boundary instead (INT-946).
export const isMarketplaceChannel = (channel: string): channel is MarketplaceChannel =>
  typeof channel === 'string' && channel.length > 0;

export const parseChannel = (channel: string | null) => (channel && isMarketplaceChannel(channel) ? channel : null);

export const parseAsMarketplaceChannel = createParser({
  parse: parseChannel,
  serialize: (value: MarketplaceChannel | null) => value?.toString() ?? '',
});
